import { divide } from "lodash";
import React, { Component } from "react";
import { Divider } from "semantic-ui-react";
import { Container, Button, Icon, Table, Image, Form, Tab, Header, Pagination, Input, Modal, Checkbox } from 'semantic-ui-react'
import config from "../config";
import  { invokeApig } from "../libs/awsLib";
import { JSONDate, lookupDescription, formatDateTime } from "../libs/sharedFunctions";
import ReactJson from 'react-json-view'
import { Link} from "react-router-dom";
import qs from 'qs';
import _ from 'lodash';

const PAGE_SIZE=20;
const NO_PAGES=100;


export default class SmartDevices extends Component {
  constructor(props) {
    super(props);
  
    const today=new Date();
    var startDate=new Date();
    startDate.setDate(today.getDate() - 1)
    var endDate=new Date();

    this.state = {
      smartDevices: [], 
      deviceID: '', 
      chfDeviceID: '', 
      mpxn: '', 
      deviceType: '', 
      deviceStatus: '', 
      activePage: 1, 
      selectedDeviceId: null
      };
  

  
 }


componentWillReceiveProps(nextProps) {
  const queryParams=qs.parse(nextProps.location.search, { ignoreQueryPrefix: true });
  this.setState({deviceID: queryParams.deviceid, chfDeviceID: queryParams.chfdeviceid, mpxn: queryParams.mpxn})
  this.loadSmartDevices(queryParams.deviceid, queryParams.chfdeviceid, queryParams.mpxn)
}

loadSmartDevices=(deviceID=this.state.deviceID, chfDeviceID=this.state.chfDeviceID, mpxn=this.state.mpxn)=>
{

  var queryParams=[];

  if (deviceID)
    queryParams.push('deviceid='+deviceID)

    if (chfDeviceID)
    queryParams.push('chfdeviceid='+chfDeviceID)

  if (mpxn)
    queryParams.push('importmpxn='+mpxn)

  invokeApig({path: "/api/smartdevices", method: "GET", queryParams: queryParams}).then((result)=>
  {
    var smartDevices=result.data;
    //sort by chf device id, device type
    smartDevices=_.sortBy(smartDevices, ['chfdeviceid', 'devicetype'])

    //add chf device counts to merge CHF rows
    var chfCounts=_.groupBy(smartDevices, 'chfdeviceid')
    chfCounts=_.mapValues(chfCounts, 'length')
    this.setState({smartDevices: smartDevices,chfCounts: chfCounts})
  });
}

connectivityImage=(connectivity)=>{
  if (connectivity==0)
  return 'no-connection-16.png'
  else if (connectivity==1)
  return 'poor-connection-16.png'
  else if (connectivity==2)
  return 'average-connection-16.png'
  else if (connectivity==3)
  return 'good-connection-16.png'
}
connectivityDescription=(connectivity)=>{
  if (connectivity==0)
  return 'None'
  else if (connectivity==1)
  return 'Poor'
  else if (connectivity==2)
  return 'Average'
  else if (connectivity==3)
  return 'Good'
}

healthCheckIcon=(connectivity)=>{
  if (connectivity==1)
  return 'check'
  else if (connectivity==2)
  return 'warning sign'
  else if (connectivity==3)
  return 'x'
}

healthCheckColour=(status)=>{
  if (status==1)
  return 'green'
  else if (status==2)
  return 'yellow'
  else if (status==3)
  return 'red'
}



componentDidMount()
{
  
  const queryParams=qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
  if (queryParams.deviceid || queryParams.chfdeviceid || queryParams.mpxn)
  {
  this.setState({deviceID: queryParams.deviceid, chfDeviceID: queryParams.chfdeviceid, mpxn: queryParams.mpxn})
  this.loadSmartDevices(queryParams.deviceid, queryParams.chfdeviceid, queryParams.mpxn)
  }
}

  render() {

    //handle pagination
    var activePage=this.state.activePage;
    var smartDevices=this.state.smartDevices.filter(smartDevice=>{return smartDevice.chfdeviceid!==null});
    if (smartDevices.length<(activePage-1)*PAGE_SIZE)
    {
      activePage=1;
      this.setState({activePage: 1})
    }
    smartDevices=smartDevices.slice((activePage-1)*PAGE_SIZE, activePage*PAGE_SIZE)
    
    return <div className="fullpage">
      <Container>
      <Header color='biue' as='h3' className={this.state.darkmode ? "darkmode" : "seaglassblue"}><Icon name='disk'/>Smart Devices</Header>
      <Form inverted={this.state.darkmode}>
        <Form.Group inline>
        <label style={{color: this.props.darkmode ? "white": "black"}}>Device Id</label>
        <Form.Input placeholder='Device Id' icon='search' value={this.state.deviceID} onChange={(event, data)=>{this.setState({deviceID: data.value}); }} />
        <label style={{color: this.props.darkmode ? "white": "black"}}>CHF Device Id</label>
        <Form.Input placeholder='CHF Device Id' icon='search' value={this.state.chfDeviceID} onChange={(event, data)=>{this.setState({chfDeviceID: data.value}); }} />
        <label style={{color: this.props.darkmode ? "white": "black"}}>MPxN</label>
        <Form.Input  placeholder='MPxN' icon='search' value={this.state.mpxn} onChange={(event, data)=>{this.setState({mpxn: data.value}); }} />
        <Button className='seaglassbutton' disabled={!(this.state.deviceID || this.state.chfDeviceID || this.state.mpxn)} onClick={()=>{this.loadSmartDevices()}}><Icon name='search'/>Search</Button>
        
        
        </Form.Group>
      </Form>
      <Table>
        <Table.Header>
        <Table.Row>
          <Table.HeaderCell>CHF Device Id</Table.HeaderCell>
          <Table.HeaderCell>Device Id</Table.HeaderCell>
          <Table.HeaderCell>Device Type</Table.HeaderCell>
          <Table.HeaderCell>MPxN</Table.HeaderCell>
          <Table.HeaderCell>DCC Status</Table.HeaderCell>
          <Table.HeaderCell>Connectivity</Table.HeaderCell>
          <Table.HeaderCell>Health Check</Table.HeaderCell>
        </Table.Row>
        </Table.Header>
        <Table.Body>  
        {smartDevices.map(smartDevice=>{
          const chfCount=this.state.chfCounts[smartDevice.chfdeviceid];
          return <Table.Row>
            {(smartDevice.devicetype==='CHF' || chfCount==1) && <Table.Cell rowSpan={chfCount}><Link to={'../smartdevices?chfdeviceid='+smartDevice.chfdeviceid}>{smartDevice.chfdeviceid}</Link></Table.Cell>}
            <Table.Cell><Link to={'../smartdevice/'+smartDevice.id}>{smartDevice.deviceid}</Link></Table.Cell>
            <Table.Cell>{smartDevice.devicetype}</Table.Cell>
            <Table.Cell>{smartDevice.importmpxn}</Table.Cell>
            <Table.Cell>{smartDevice.devicestatus}</Table.Cell>
            <Table.Cell textAlign='center'>{smartDevice.connectivity!==null ? <img src={require('../images/'+this.connectivityImage(smartDevice.connectivity))}/> : null}</Table.Cell>           
            <Table.Cell textAlign='center'><Icon size='large' name={this.healthCheckIcon(smartDevice.healthcheckstatus)} color={this.healthCheckColour(smartDevice.healthcheckstatus)}/></Table.Cell>   
            </Table.Row>
        })}
        </Table.Body>
        </Table>
        <Pagination activePage={this.state.activePage} totalPages={Math.ceil(smartDevices.length/PAGE_SIZE)} onPageChange={(event, { activePage })=>{this.setState({activePage: activePage})}}/> 
      </Container>
      </div>

   }
}
